import { getContactInfo } from '../../../common/utils/stateUtils.js';
import { CookieConsent } from '../../../components/CookieConsent/CookieConsent.js';
import { AnalyticsConsent } from '../../../generated/api/analyticsConsent.js';
import { useAuth } from '../AuthProvider.js';

export const CookieConsentWrapper = () => {
  const { authenticatedUser, updateUserDetails } = useAuth();

  const saveAnalyticsConsent = (flag: boolean) => {
    if (authenticatedUser?.businessId !== undefined) {
      updateUserDetails({
        ...getContactInfo(authenticatedUser),
        analyticsConsent: flag ? AnalyticsConsent.ALLOWED : AnalyticsConsent.DENIED,
      });
    }
  };

  return (
    <CookieConsent
      saveAnalyticsConsent={saveAnalyticsConsent}
      hasAcceptedAnalyticsCookies={authenticatedUser?.analyticsConsent !== AnalyticsConsent.UNSET}
    />
  );
};
